(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_4313bd4"] && !Shopify.designMode) return;
  try {
    (function () {
  var ARROW_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12H4M10 6l-6 6 6 6"/></svg>';
  var ARROW_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12h16M14 6l6 6-6 6"/></svg>';

  function setup(scroller) {
    if (scroller.dataset.ncNav) return;
    scroller.dataset.ncNav = '1';

    var nav = document.createElement('div');
    nav.className = 'nc-swipe-nav';
    nav.innerHTML =
      '<button type="button" class="nc-swipe-nav__btn" aria-label="前へ">' + ARROW_L + '</button>' +
      '<button type="button" class="nc-swipe-nav__btn" aria-label="次へ">' + ARROW_R + '</button>';
    scroller.insertAdjacentElement('afterend', nav);

    var prev = nav.children[0], next = nav.children[1];

    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth;
      nav.classList.toggle('is-scrollable', max > 4);
      prev.disabled = scroller.scrollLeft <= 4;
      next.disabled = scroller.scrollLeft >= max - 4;
    }
    function go(dir) {
      var card = scroller.querySelector('[data-article-card], [data-view-all-card]');
      var step = card ? (card.getBoundingClientRect().width + 16) : 216;
      var n = Math.max(1, Math.floor(scroller.clientWidth / step) - 1);
      scroller.scrollBy({ left: dir * step * n, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(update);
      ro.observe(scroller);
      if (scroller.firstElementChild) ro.observe(scroller.firstElementChild);
    }
    update();
  }

  function init() {
    document.querySelectorAll('[data-swipe-wrapper]').forEach(function (w) {
      if (w.parentElement) setup(w.parentElement);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

})();
